<template>
  <div class="registration" v-loading="loading">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="诊断">
          <el-input v-model="filters.diagnose" clearable></el-input>
        </el-form-item>
        <el-form-item label="规范手术名称">
          <el-input v-model="filters.operationName" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class=" buttonText">
        <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
        <el-button type="danger" @click="del" icon="el-icon-delete">删除</el-button>
        <!-- <div class="delete" @click="del">删除</div>
        <div class="addData" @click="add">新增</div> -->
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{ color: '#626365' }">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号" width="100"></el-table-column>
        <el-table-column sortable prop="operationName" width="140" label="手术(治疗)名称"></el-table-column>
        <el-table-column sortable prop="agoOperationName" width="120" label="原手术名称"></el-table-column>
        <el-table-column sortable prop="diagnosisName" label="诊断"></el-table-column>
        <el-table-column sortable prop="operationExplain" width="140" label="手术细则说明"></el-table-column>
        <el-table-column sortable prop="detailsExplain" label="说明"></el-table-column>
        <el-table-column sortable prop="operationNo" width="120" label="手术编号"></el-table-column>
        <el-table-column sortable prop="operationGrade" width="120" label="手术级别">
          <template slot-scope="scope">
            <span v-if="scope.row.operationGrade==1">一级</span>
            <span v-if="scope.row.operationGrade==2">二级</span>
            <span v-if="scope.row.operationGrade==3">三级</span>
            <span v-if="scope.row.operationGrade==4">四级</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="therapeuticIndex" width="120" label="治疗指数"></el-table-column>
        <el-table-column sortable prop="registerType" width="120" label="登记表">
          <template slot-scope="scope">
            <span v-if="scope.row.registerType==1">外科</span>
            <span v-if="scope.row.registerType==2">注射微整科</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="anesthesiaMode" label="麻醉方式">
          <template slot-scope="scope">
            <span v-if="scope.row.anesthesiaMode==0">其他</span>
            <span v-if="scope.row.anesthesiaMode==1">全麻</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="createBy" label="添加人" width="150"></el-table-column>
        <el-table-column sortable prop="createTime" label="添加时间" width="100"></el-table-column>
        <el-table-column prop="forbidden" label="禁用" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="statuChange(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button :disabled="scope.row.menuType==2?true:false" size="mini" type="warning" @click="handleCopy(scope.$index, scope.row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 外科新增和编辑弹框 -->
    <el-dialog :visible.sync="editSkinDialog" v-if="editSkinDialog" width="50%" center class="dialogItem" :close-on-click-modal="false">
      <editNosis :code="code" :menuType="menuType" :formData="formData" @closeDialog="closeDialog" @add-comment="appendComment"></editNosis>
    </el-dialog>
  </div>
</template>
<script>
import editNosis from "./editNosis.vue";
export default {
  name: 'injectDiagnosis',
  components: {
    editNosis
  },
  data() {
    return {
      formData: {},
      filters: {
        types: "",
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
        },
        operationName: '',
        diagnose: '',
        startTime: "",
        endTime: "",
      },
      tableData: [],
      loading: false,
      productOption: this.$store.state.productOption,
      editSkinDialog: false,
      tableHeight: '',
      menuType: '',
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page;
      this.refresh();
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes;
      this.refresh();
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge(
          {},
          this.$route.query,
          {
            __query: JSON.stringify(this.pagination),
          },
          {
            random: Math.random(),
          }
        ),
      });
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    // 查询
    query(page) {
      let querys = {
        startTime: "",
        endTime: "",
        page: page,
        size: this.filters.pagination.limit,
        operationName: this.filters.operationName,
        diagnose: this.filters.diagnose,
      };
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0];
        querys.endTime = this.filters.startTime[1];
      }
      api.request(
        "/register/findOperationMenuPage",
        querys,
        (res) => {
          // console.log(res)
          var data = res.data.list;
          this.tableData = data;
          this.tableData.forEach((ele) => {
            ele.opear = "/";
          });
          this.filters.pagination.total = parseInt(res.data.count);
        }
      );
    },
    // 编辑
    handleEdit(index, row) {
      console.log(row);
      this.editSkinDialog = true
      this.code = 1
      this.menuType = row.menuType
      api.request(
        "/register/findOperationMenuById",
        {
          registerMenuId: row.id,
          menuType: row.menuType
        },
        (res) => {
          console.log(res)
          this.formData = res.data
        }
      );
    },
    // 复制
    handleCopy(index, row) {
      console.log(row);
      this.editSkinDialog = true
      this.code = 2
      this.menuType = row.menuType
      api.request(
        "/register/findOperationMenuById",
        {
          registerMenuId: row.id,
          menuType: row.menuType
        },
        (res) => {
          console.log(res)
          this.formData = res.data
        }
      );
    },
    add() {
      this.editSkinDialog = true
      this.code = 0//1编辑0新增
      this.formData = {
        type: '',
        diagnosisMenuList: [{
          operationName: '',
        }],
        operationNameList: [{
          menuName: ''
        }],
        registerType: ''
      }
    },
    // 删除项目
    del() {
      let newData = this.multipleSelection.map(
        ({ id, menuType }) =>
          ({ id, menuType })
      );
      let data = { deleteMenuList: newData }
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet("/register/deleteOperationMenu", data,
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    closeDialog() {
      this.editSkinDialog = false
    },
    // 子组件添加完之后刷新父组件
    appendComment(item) {
      if (this.filters.operationName == '' && this.filters.diagnose == '') {
        this.query(this.filters.pagination.page);
      } else {
        this.query(1);
      }
    },
    statuChange(index, row) {
      let data = {
        id: row.id,
        menuType: row.menuType
        // 0：正常 1：禁用
      }
      api.request("/register/updateDiagnosisAndOperationMenuForbidden", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "状态修改成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "状态修改失败")
          this.query(this.filters.pagination.page)
        }
      })
    },
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 350
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/main.css";
.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}
</style>
